<template>
  <div class="text-left">
    <div v-if="view=='existing' && !executing">
      <div v-if="!location.useJitsi">
        <div>
          <b>Current Venue: </b> {{ location.venue }}
        </div>
        <div>
          <mdb-btn @click="view='new'" icon="plus-circle" rounded size="sm">New Venue</mdb-btn>
          <mdb-btn @click="toggleJitsi" v-if="currentGroup.jitsiEnabled" rounded size="sm" icon="browser">
            Make it an Ezumee Meet Meeting
          </mdb-btn>
        </div>
        <div class="mt-4"><h4>Or...</h4></div>
        <mdb-select @getValue="valueSelected" label="Change venue to" search v-model="allVenues"/>
        <mdb-btn @click="doSaveExisting" :disabled="!selectedVenue">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </div>
      <div v-if="location.useJitsi">
        <mdb-btn @click="toggleJitsi" rounded size="sm" icon="browser">
          Remove Ezumee Meet Meeting
        </mdb-btn>
      </div>
      <mdb-btn @click="doCancel">
        <mdb-icon icon="window-close"/>
        Cancel
      </mdb-btn>
    </div>

    <div v-if="view=='new'">
      <mdb-input label="Name" placeholder="Venue Name" type="text" v-model="newData.name"/>
      <mdb-input label="Address" placeholder="Address or GPS Coordinates" type="text" v-model="newData.address"/>
      <mdb-input label="URL" placeholder="Address of venue website or other external information" type="text"
                 v-model="newData.url"/>
      <editor :init="editorConfig" v-model="newData.details"/>
      <mdb-modal :show="showImageSelector" @close="showImageSelector = false" class="gp-z-2000">
        <mdb-modal-header :close="true" center>Select an Image
        </mdb-modal-header>
        <mdb-modal-body>
          <image-selector :group="currentGroup" @imageSelected="imageSelected" emitOnSelection="imageSelected"/>
        </mdb-modal-body>
      </mdb-modal>

      <mdb-btn @click="doSaveNew" v-if="newData.name">
        <mdb-icon icon="save"/>
        Save
      </mdb-btn>
      <mdb-btn @click="doCancel">
        <mdb-icon icon="window-close"/>
        Cancel
      </mdb-btn>
    </div>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import editor from '@tinymce/tinymce-vue'
import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalHeader, mdbSelect} from 'mdbvue';
import imageSelector from '../group/ImageSelector'
import SeriesModal from "./SeriesModal";

export default {
  name: 'Event-Location-Editor',
  components: {
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbSelect,
    mdbInput,
    imageSelector,
    editor,
    SeriesModal
  },
  props: {
    location: {
      type: Object,
      default: null
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    }
  },
  data() {
    return {
      allVenues: [],
      view: "existing",
      selected: false,
      selectedVenue: null,
      newData: {type: "new", name: "", address: "", url: "", details: ""},
      showImageSelector: false,
      showSeriesModal: false,
      seriesChoice: null,
      seriesFunction: null,
      editorConfig: {
        selector: '.tinymce_group_content',
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
        file_picker_callback: this.myFileBrowser,
        image_advtab: true,
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        style_formats: [{
          title: 'Image Left',
          selector: 'img',
          styles: {
            'float': 'left',
            'margin': '0 10px 0 10px'
          }
        },
          {
            title: 'Image Right',
            selector: 'img',
            styles: {
              'float': 'right',
              'margin': '0 0 10px 10px'
            }
          },
          {
            title: 'GP Heading',
            block: 'div',
            classes: 'tile_title'
          }
        ]
      }
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", true);
    api.get("/venue/listActive/" + this.currentGroup.vanityPath).then(
      (results) => {
        this.allVenues = results.data
      },
      (error) => {
        this.$notify.error({message: "Could not load venue list", timeOut: 10000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    valueSelected(v) {
      this.selectedVenue = v
    },
    setSeriesChoice(choice) {
      this.seriesChoice = choice
      this[this.seriesFunction]()
    },
    doSaveExisting() {
      if (this.location.repeats && !this.seriesChoice && this.location.status != "Draft") {
        this.showSeriesModal = true
        this.seriesFunction = "doSaveExisting"
        return
      }
      this.$store.dispatch("setExecuting", true);
      let d = {type: "existing", venue: this.selectedVenue}
      if (this.location.repeats && this.seriesChoice) d.series = this.seriesChoice
      api.post("/event/venue/" + this.location.eventId, d).then(
        (results) => {
          this.$emit("saveLocation", results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.seriesChoice = null
        this.showSeriesModal = false
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleJitsi() {

      if (this.location.repeats && !this.seriesChoice && this.location.status != "Draft") {
        this.showSeriesModal = true
        this.seriesFunction = "toggleJitsi"
        return
      }
      this.$store.dispatch("setExecuting", true);
      let data = { useJitsi: !this.location.useJitsi};
      if (this.location.repeats && this.seriesChoice) data.series = this.seriesChoice
      api.post("/event/toggleJitsi/" + this.location.eventId, data).then(
        (results) => {
          this.location.useJitsi = data.useJitsi
          this.showSeriesModal = false
          this.$emit("jitsiToggled", data.useJitsi)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    async doSaveNew() {

      if (await this.checkExisting()) {
        this.$notify.error({message: "A venue with that name already exists.", timeOut: 10000})
        return
      }

      if (this.location.repeats && !this.seriesChoice && this.location.status != "Draft") {
        this.showSeriesModal = true
        this.seriesFunction = "doSaveNew"
        return
      }
      await this.$store.dispatch("setExecuting", true);
      if (this.location.repeats && this.seriesChoice) this.newData.series = this.seriesChoice
      api.post("/event/venue/" + this.location.eventId, this.newData).then(
        (results) => {
          this.$emit("saveLocation", results.data)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {

        this.$store.dispatch("setExecuting", false)
        this.seriesChoice = null
        this.showSeriesModal = false
        this.$store.dispatch("setExecuting", false)

      })
    },
    doCancel() {
      this.$emit("cancelLocation")
    },
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      this.imageCallback(image.url, {width: "33%", height: ""})
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      this.showImageSelector = true
      this.imageCallback = callBack
    },
    async checkExisting() {
      await this.$store.dispatch("setExecuting", true);
      let ret = false
      await api.post("/venue/find/" + this.currentGroup.vanityPath, {name: this.newData.name}).then(
        (results) => {
          if (results.data.count > 0) {
            console.log("Count is ", results.data.count)
            ret = true;
          }
        },
        (error) => {
          this.$notify.error({message: "Could not validate venue name.", timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
      return ret;
    }

  }
}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
